<template>
    <modal name="update_service" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update service')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-multi-lang-textarea id="name"
                                             v-model="form.name"
                                             name="name"
                                             rules="required"
                                             :langs="locales && Object.keys(locales)">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-multi-lang-textarea>

                    <template v-if="service_id < 3">
                        <app-input id="days" v-model="form.condition.days" type="number" max="100" name="days" rules="required">
                            <template #label>
                                {{ $t('Days') }}
                            </template>
                        </app-input>

                        <app-input id="price" v-model="form.condition.price" type="number" max="100" name="price" rules="required">
                            <template #label>
                                {{ $t('Price') }}
                            </template>
                        </app-input>
                    </template>

                    <template v-if="service_id === 3">
                        <app-input id="price_1st_hr" v-model="form.condition.price_1st_hr" type="number" max="100" name="price_1st_hr" rules="required">
                            <template #label>
                                {{ $t('Price 1st hour') }}
                            </template>
                        </app-input>

                        <app-input id="price_2nd_hr" v-model="form.condition.price_2nd_hr" type="number" max="100" name="price_2nd_hr" rules="required">
                            <template #label>
                                {{ $t('Price 2nd hour') }}
                            </template>
                        </app-input>
                    </template>

                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import PaidServiceService from '@services/paidService.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            loading: false,
            service_id: null
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    PaidServiceService.update(this.service_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setService', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const service = event.params.service;
            if (service) {
                this.form.name = Object.assign({}, service.name);
                this.form.condition = Object.assign({}, service.condition);
                this.service_id = service.id;
            }
        },
        hide() {
            this.$modal.hide('update_service');
        }
    }
};
</script>
